module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue4.9bc9db8470f157e9e6a071a1fd6c404f.png";